import foodbank from "../assets/images/foodbank.png";
import bookio from "../assets/images/bookio1.png";
import shopistry from "../assets/images/shopistry.png";
import trexo from "../assets/images/trexo1.png";
import climbingnets from "../assets/images/climbing-nets-cover.svg";
import wordflowsvenska from "../assets/images/wordflowsvenska.png";

export const ProjectList = [
  {
    id: 0,
    title: "Trexo",
    cover: trexo,
    descrption:
      "Trexo is expense tracking application. Built with Node.js, Express.js, React TS",
    project_link: "https://github.com/riaars/FinanceTrackingFrontend",
    project_web: "http://ec2-16-170-207-107.eu-north-1.compute.amazonaws.com/",
    type: "Software Development",
    hasContent: false,
    hasURL: true,
  },

  {
    id: 1,
    title: "Svenska Wordflow",
    cover: wordflowsvenska,
    descrption:
      "Svenska Wordflow is a mini wordflow game to help newbie to learn swedish",
    project_link: "https://github.com/riaars/WordFlowGameSvenska",
    project_web:
      "https://word-flow-game-svenska-eaq7lrdny-rias-projects-18d5096e.vercel.app/",
    type: "Software Development",
    hasContent: false,
    hasURL: true,
  },

  {
    id: 2,
    title: "BOOKIO",
    cover: bookio,
    descrption:
      "Bookio is a sharing book platform to allow the customer to get, lend, borrow, or give book to someone else in order to maintain sustainability while increasing the literacy.",
    project_link: "https://github.com/bt-s/BOOKIO",
    project_web: "https://bookio-5c798.firebaseapp.com/",
    type: "Software Development",
    hasContent: false,
    hasURL: true,
  },

  {
    id: 3,
    title: "Climbing with Light",
    cover: climbingnets,
    descrption:
      " An interactive climbing nets with light and sound for dark winter playground in Sweden.",
    project_link: "/climbing-light",
    project_web: "https://vimeo.com/368869269",
    type: "UI/UX Design",
    hasContent: true,
    hasURL: true,
  },

  {
    id: 4,
    title: "Shopistry",
    cover: shopistry,
    descrption:
      "Shopistry is a mobile platform to help mystery shoppers to perform the tasks onsite without suspicious.",
    project_link: "/shopistry",
    project_web: "#",
    type: "UI/UX Design",
    hasContent: true,
    hasURL: false,
  },

  {
    id: 5,
    title: "Food Sharer",
    cover: foodbank,
    descrption:
      "Foodsharer is a propose solution platform to enable the connectness between food bank staff with charity organization in Sweden to reduce food waste.",
    project_link: "/foodsharer",
    project_web: "#",
    type: "UI/UX Design",
    hasContent: true,
    hasURL: false,
  },
];

export const FilterMenu = [
  {
    id: 0,
    title: "All",
  },
  {
    id: 1,
    title: "Software Development",
  },
  {
    id: 2,
    title: "UI/UX Design",
  },
];
